"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converters = void 0;
const postman2openapi_1 = require("postman2openapi");
const openapi_1 = require("./openapi");
exports.converters = {
    '3.0.0': from_postman_to_asyncapi
};
function from_postman_to_asyncapi(postman, options = {}) {
    const perspective = options.perspective;
    const openapi = (0, postman2openapi_1.transpile)(postman);
    const asyncapi = (0, openapi_1.from_openapi_to_asyncapi)(openapi, { perspective: perspective });
    return asyncapi;
}
